/* eslint-disable no-unused-vars */
import React, { Component } from 'react';
import { Form, Button, Input, Row, Col } from 'antd';
import { connect } from 'react-redux';

import { getAccountSearch } from '@store/modules/core_account_search';

const { TextArea } = Input;
class Eidtor extends Component {
  state = {
    content: '',
    atUuids: [],
  };

  componentDidMount() {
    this.props.dispatch(getAccountSearch());
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.submitting !== nextProps.submitting && nextProps.submitting === false) {
      this.setState({
        content: '',
        atUuids: [],
      });
    }
  }

  handleMention = e => {
    this.setState({
      atUuids: e,
    });
    this.props.onMention(e);
  };

  handleChange = e => {
    let { value } = e.target;
    if (value && value.length > 210) {
      value = value.substring(0, 210);
    }
    this.setState({
      content: value,
    });
    this.props.onChange(e);
  };

  render() {
    const { onSubmit, submitting, placeholder, options } = this.props;
    const { atUuids, content } = this.state;
    return (
      <div>
        <Form.Item style={{ marginBottom: '10px' }}>
          <TextArea
            autosize={{ minRows: 2, maxRows: 6 }}
            onChange={this.handleChange}
            placeholder={placeholder}
            value={content}
          />
          <span style={{ fontSize: '12px', color: '#999' }}>*最多可输入200字</span>
        </Form.Item>
        <Row>
          <Col span={12}>
            {/* <Form.Item label="提醒谁看" style={{display: "flex"}}>
							<Select
								style={{width: "350px"}}
								mode="tags"
								placeholder="选择"
								filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
								onChange={this.handleMention}
								value={atUuids}
							>
								{options.map(item => <Option key={item.uuid}>{item.name}</Option>)}
							</Select>
						</Form.Item> */}
          </Col>
          <Col span={12}>
            <Form.Item style={{ textAlign: 'right', marginBottom: '10px' }}>
              <Button htmlType="submit" loading={submitting} onClick={onSubmit} type="primary">
                评论
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </div>
    );
  }
}
export default connect(state => ({
  options: state.core_account_search,
}))(Eidtor);



// WEBPACK FOOTER //
// ./src/components/comm/comment/Editor.js